'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pack = function pack() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField,
      _ref$childrenField = _ref.childrenField,
      childrenField = _ref$childrenField === undefined ? 'children' : _ref$childrenField;

  return function (rows) {
    if (!(0, _isArray3.default)(rows)) {
      return [];
    }

    if (!rows.length) {
      return rows;
    }

    var ret = [];
    var previousParents = void 0;

    // Clone deep to guarantee immutability (implementation relies on
    // references)
    (0, _cloneDeep3.default)(rows).forEach(function (row) {
      var rowParent = row[parentField];

      if (typeof rowParent !== 'undefined' && rowParent !== null) {
        // Check if the parent field matches the accumulated potential parents
        var foundParent = (0, _find4.default)(previousParents, _defineProperty({}, idField, rowParent));

        if (foundParent) {
          // Found the matching parent, set up children + push
          if (!foundParent[childrenField]) {
            foundParent[childrenField] = [];
          }

          foundParent[childrenField].push((0, _omit3.default)(row, parentField));

          previousParents.push(last(foundParent[childrenField]));
        } else {
          console.warn('tree.pack - Invalid parent id', row, previousParents); // eslint-disable-line no-console
        }
      } else {
        ret.push(row);

        // No parents, flush lookup
        previousParents = [row];
      }
    });

    return ret;
  };
};

function last(arr) {
  return arr[arr.length - 1];
}

exports.default = pack;